// removed by extract-text-webpack-plugin
module.exports = {"container":"_3uaDf","body":"rEYSL","title":"_1JAUZ","content":"_1XLoh","question":"_3HRAp","link":"_16IU4","action":"_3ql7Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Faq.less
// module id = ./src/components/Home/Faq.less
// module chunks = 2